import React from "react";
import { Card, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Logo from "../Components/Logo";

let Error = () => {
  let history = useHistory()
  return (
    <Card className="main-card d-flex align-items-center justify-content-center p-5 h-100 w-100">
      <Logo />
      <h1 className="text-danger error-text mt-1">404</h1>
      <h3 className="text-danger success-text">Page not found</h3>
      <p className="success-text">
        The page you're looking for doesn't exist or is unavailable.
      </p>
      <Button className="jr-btn" onClick={() => {
        history.push('/')
      }}>
        Redirect to Log In
      </Button>
    </Card>
  );
};

export default Error;
